import { render, staticRenderFns } from "./replacement.vue?vue&type=template&id=175427b2&scoped=true&"
import script from "./replacement.vue?vue&type=script&lang=js&"
export * from "./replacement.vue?vue&type=script&lang=js&"
import style0 from "./replacement.vue?vue&type=style&index=0&id=175427b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175427b2",
  null
  
)

export default component.exports